import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import IntakePage from "./pages/IntakePage";
import AboutPage from "./pages/AboutPage";
import TeamPage from "./pages/TeamPage";
import ContactPage from "./pages/ContactPage";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./theme/ThemeProvider";
import SmoothScroll from "./components/SmoothScroll";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <SmoothScroll>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/intake" element={<IntakePage />} />
            </Routes>
          </BrowserRouter>
        </SmoothScroll>
        <FloatingWhatsApp />
        <Toaster
          position="top-right"
          toastOptions={{
            classNames: {
              toast: "!bg-cream-50 !border !border-cream-300 !text-charcoal !rounded-none !font-sans",
              title: "!font-serif",
            },
          }}
        />
      </ThemeProvider>
    </div>
  );
}

export default App;
